import { render, staticRenderFns } from "./SingleEditRaceNumber.vue?vue&type=template&id=64956574&scoped=true&"
import script from "./SingleEditRaceNumber.vue?vue&type=script&lang=js&"
export * from "./SingleEditRaceNumber.vue?vue&type=script&lang=js&"
import style0 from "./SingleEditRaceNumber.vue?vue&type=style&index=0&id=64956574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64956574",
  null
  
)

export default component.exports